// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"93eefd78","391":"c0b8251c","435":"30abab97","441":"22530e92","681":"25f7e32c","787":"67998abe"}[chunkId] + ".chunk.js";
};